Vue.component('guestflip-hint', {
  props: ['team_id', 'review_id', 'respond_url', 'activeHint', 'review', 'user', 'hasReviewResponseApproval', 'isResponseLoading'],

  watch: {
    activeHint: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.hintText = newValue?.hint_text;
      },
    },
  },

  data() {
    return {
      hintTitle: 'Click to copy',
      externalLink: 'Click to redirect to review source',
      editPlaceholdersOn: false,
      hintText: '',
      direction: 'ltr',
      isResponseSuggestion: false,
      commentUpdatedAtBy: '',
      response: '',
      lastEditedByUserName: '',
    };
  },

  computed: {
    hintRating() {
      return this.hint ? this.hint.rating.replace('mark_as_', '') : '';
    },
    isHintChanged() {
      return this.hint && this.hintText != this.hint.hint_text;
    },
    hasSuggestionComment() {
      return this.review.comments.some((comment) => comment.kind === 'suggestion');
    },
    responseLastEditedBy() {
      return this.lastEditedByUserName;
    },
  },

  mounted() {
    // Pass this data on to the parent
    this.$on('hintLoading', (bool) => this.$parent.$emit('hintLoading', bool));
    this.$on('hintReady', (hint) => this.$parent.$emit('hintReady', hint));
    this.$on('setDirection', (dir) => this.setDirection(dir));
    this.setCurrentSuggestion();
    this.fetchLastEditedByUserName();
  },

  methods: {
    fetchLastEditedByUserName() {
      const suggestionComment = this.review.comments.find((comment) => comment.kind === 'suggestion');
      if (suggestionComment) {
        const userId = suggestionComment.updated_by;
        axios.get(`/api/users/${userId}/name`).then((response) => {
          this.lastEditedByUserName = response.data.name;
        });
      }
    },
    setCurrentSuggestion() {
      const suggestionComment = this.review.comments.find((comment) => comment.kind === 'suggestion');
      if (suggestionComment) {
        this.hintText = suggestionComment.comment;
      }
    },
    redirectToRespondURL() {
      if (this.review.api_source === 'expedia') {
      window.open('https://www.expediapartnercentral.com/manageproperty/ManageProperty?returnUrl=https://apps.expediapartnercentral.com/lodging/review/user_reviews.html', '_blank');
      } else {
      window.open(this.respond_url, '_blank');
      }
    },
    copyText() {
      let textArea = document.createElement('textarea');
      textArea.value = this.hintText;
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        this.hintTitle = 'Copied !';
      } catch (err) {
        alert('Oops!', 'Failed to copy text', 'danger');
      }
      document.body.removeChild(textArea);
    },
    saveResponseSuggestion() {
      const { id: reviewId, team_id: teamId } = this.review;
      const commentSuggestion = this.hintText;
      const userId = this.user.id;
      axios
        .post(`/api/reviews/${teamId}/${reviewId}/responseSuggestion`, { commentSuggestion, userId })
        .then(() => {
          swal('Successful', 'Response suggestion saved successfully', 'success');

          // Retrieve the updated comment
          return axios.get(`/api/reviews/${reviewId}/comments`);
        })
        .then((response) => {
          // Update the comments in the review object
          this.review.comments = response.data.comments;
          const updatedComment = response.data.comments.find((comment) => comment.kind === 'suggestion');
          if (updatedComment) {
            this.review.commentUpdatedAtBy = updatedComment.updated_by;
            this.commentUpdatedAtBy = updatedComment.updated_by;
          }
        })
        .catch((error) => {
          console.log(error);
          swal('Failed', 'Failed to save comment suggestion', 'error');
          this.isResponseSuggestion = true;
        });
    },
    setDirection(value) {
      this.direction = value;
    },
    defaultHintTitle(event) {
      elem = event.srcElement;
      this.hintTitle = 'Click to copy';
      // this.updateTooltip(elem, this.hintTitle)
    },
    editPlaceholders() {
      this.editPlaceholdersOn = !this.editPlaceholdersOn;
    },
    editTemplates() {
      $(this.$refs.editTemplatesModal).modal('toggle');
    },
    updateTooltip(element, title) {
      $(element).tooltip('hide').attr('data-original-title', title).tooltip('show');
    },
    addHintTag(actionName) {
      let payload = {
        action: actionName,
      };

      link = '/api/reviews/hints/' + this.hint.id + '/tag-hint';

      axios.post(link, payload).then((response) => {
        this.$parent.$emit('hintReady', response.data.hint);
      });
    },
    rateHint(type) {
      analytics.track('Rated Hint', {
        rated_as: type,
      });

      this.addHintTag('mark_as_' + type);

      this.$notify({
        group: 'reviews',
        title: 'Update',
        text:
          'The hint was marked as ' +
          type.replace('_', ' ') +
          '! This helps us improve the quality of responses in the future.',
        position: 'bottom right',
      });
    },
    respond() {
        this.$parent.$emit('setResponseMessage', this.hintText)
        this.$parent.$emit('respond')
    }
  },
});
